const conjunctionOperators = [
  '&&',
  '||'
];

const unaryOperators = [
  'present?',
  'blank?'
];

const operatorDisplayName = (operator) => {
  switch (operator) {
    case '==':
      return 'is';
    case '!=':
      return 'is not';
    case '&&':
      return 'AND';
    case '||':
      return 'OR';
    case 'include?':
      return 'contains';
    case 'starts_with?':
      return 'starts with';
    case 'ends_with?':
      return 'ends with';
    case 'present?':
      return 'is not blank';
    case 'blank?':
      return 'is blank';
    default:
      return operator;
  }
};

const stringifyCriteria = (criteria, getField = () => null) => {
  if (!criteria) {
    return '';
  }

  if (conjunctionOperators.includes(criteria.operator)) {
    return criteria.criteria
      .map((crit) => `(${stringifyCriteria(crit, getField)})`)
      .join(` ${operatorDisplayName(criteria.operator)} `);
  }

  const fieldMapping = criteria && getField(criteria.field);
  const fieldName = (fieldMapping && fieldMapping.display_name) || criteria.field || '(field name)';
  const operator = operatorDisplayName(criteria.operator) || '...';

  if (unaryOperators.includes(criteria.operator)) {
    return `${fieldName} ${operator}`;
  }

  let displayValue = criteria.display_value;

  if (!displayValue) {
    displayValue = criteria.value;

    // Look for display value in the options array. An option that is itself an
    // array will be of the form: [<display value>, <value>].
    if (fieldMapping && fieldMapping.options) {
      const option = fieldMapping.options.find(
        option => Array.isArray(option) && criteria.value === option[1]);
      if (option) {
        displayValue = option[0];
      }
    }
  }

  return `${fieldName} ${operator} ${displayValue || '(blank)'}`;
};

export default stringifyCriteria;
